<img src="/svg/logos/PaxrayLogo.svg" alt="Paxray Logo" />

<style>
  img {
    width: 100%;
    max-height: 100%;
  }
</style>
